// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__czJTD","col":"Table_col__1-sN8","fulfillmentStatus":"Table_fulfillmentStatus__2oVZE","emailCol":"Table_emailCol__2zpzk"};